import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import generateScript from 'Components/Blog/content/generate-script';

export default function SurveyMonkey({ body }) {
  const script = get(body, 'primary.slice_text[0].text');
  const srcLink = script.split('"')[3];

  useEffect(() => {
    generateScript(srcLink, 'surveymonkey');
  }, [srcLink]);

  return (
    <div id="surveymonkey">
      <div id="smcx-sdk" className="m-auto" />
    </div>
  );
}

SurveyMonkey.propTypes = {
  body: PropTypes.shape({
    slice_type: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    primary: PropTypes.shape({}),
  }).isRequired,
};
